import { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';
import { Tab, TabProp } from '@fx-ui/fine-design';

type FrostedTabProps = PropsWithChildren<Omit<TabProp, 'theme'>>;

/**
 * 磨砂质感（毛玻璃效果）的 Tab 组件
 */
const FrostedTab: FC<FrostedTabProps> = ({ className, children, ...restProps }) => {
    return (
        <Tab className={classNames('fx-frosted-tab', className)} theme="cube" {...restProps}>
            {children}
        </Tab>
    );
};

export default FrostedTab;
